const l10n: FooterL10n = {
  "linkList": {
    "companyLink": "关于我们",
    "termsOfService": "使用条款",
    "privacyPolicy": "隐私政策",
    "guaranteeOfRights": "数据主体的权利",
    "customerSupport": "支持",
    "cookiePolicy": "Cookie 政策",
    "declarationOfSafety": "安全性・安全声明",
    "youthProtectionPolicy": "青少年保护政策",
    "communityPolicy": "社区政策",
    "probability": "概率",
    "operationPolicy": "运营政策",
    "doNotSell": "不要出售我的个人信息",
    "gameGrade": "评级",
    "communityPolicyView": "커뮤니티정책",
    "servicePolicy": "서비스정책",
    "termsOfUse": "使用条款",
    "operationPolicyNCJ": "운영방침",
    "reportRightsInfringement": "권리침해신고",
    "ncPrivacyCenter": "NC Privacy Center",
    "commercialTransactions": "특정상거래법에 의거한 표기",
    "settlementFund": "자금결제법에 따른 표시",
    "serviceTerm": "서비스 이용약관",
    "legalDocumentation": "法律文件",
    "googleAPIDisclosure": "谷歌 API 披露",
    "report": "신고하기",
    "serviceConsent": "NC 服务同意",
    "careers": "Careers",
    "termsOfMobile": "모바일게임 약관",
  },
  "footerWords": {
    "gameRelatedLaw": "根据游戏相关法律的额外信息",
    "brandInformation": "公司名称信息",
    "copyright": "版权",
    "channelingInfo": "NC 作为通信销售中介方，仅负责在 plaync 平台上提供渠道游戏服务，并非上述销售的销售方。<br>与所提供渠道游戏相关的所有义务与责任均由各通信销售商承担，对于由此产生的任何问题，本公司概不负责。",
  },
  "infoCS": {
    "businessInformation": "查看企业信息",
    "infoAddress": "公司名称：NC 公司，共同代表 Kim Taek-Jin、Park Byung-Moo，企业注册号：220-81-43000，<br>E-commerce Registration: 2026-Seongnam Bundang A-0316",
    "infoAddressNCV": "新加坡莱佛士坊 9 号共和大厦 26-01（邮编：048619）",
    "mobile": "地址：韩国京畿道城南市盆唐区大王板桥路 644 号街 12 号。<br>客户支持：+82 1600-0020。传真：+82 02-2186-3550。",
    "pc": "地址：韩国京畿道城南市盆唐区大王板桥路 644 号街 12 号。<br>客户支持：+82 1600-0020。传真：+82 02-2186-3550。",
    "ncfamilyzone": "地址：韩国京畿道城南市盆唐区大王板桥路 644 号街 12 号。<br>客户支持：+82 1600-0020。传真：+82 02-2186-3550。",
    "other": "地址：韩国京畿道城南市盆唐区大王板桥路 644 号街 12 号。<br>客户支持：+82 1600-0020。传真：+82 02-2186-3550。",
    "none": "",
    "infoEmail": "电子邮件",
    "infoEmail-mobile": "MobileCS@ncsoft.com",
    "infoEmail-pc": "credit@ncsoft.com",
    "infoEmail-ncfamilyzone": "ncfamilyzone@ncsoft.com",
    "infoEmail-other": "credit@ncsoft.com/（PC 游戏）/MobileCS@ncsoft.com/（手机游戏）",
    "infoEmail-none": "",
  },
  "infoJP": {
    "jpTitle": "游戏名称",
    "jpGenre": "类型",
    "jpPrice": "价格",
    "jpPriceValue": "免费游戏（包含应用内购买）",
    "jpOs": "支持的操作系统",
    "jpPlatform": "平台",
    "jpDevelopedBy": "开发商/发行商",
    "jpReleaseDay": "发布日期",
    "jpReleaseDayValue_LW": "2021 年 11 月 04 日",
  },
  "country": {
    "KR": "韩国",
    "TW": "中国台湾",
    "RU": "俄罗斯",
    "MY": "马来西亚",
    "SA": "沙特阿拉伯",
    "SG": "新加坡",
    "AE": "阿联酋",
    "ID": "印度尼西亚",
    "JP": "日本",
    "QA": "卡塔尔",
    "TH": "泰国",
    "PH": "菲律宾",
    "HK": "中国香港",
    "UA": "乌克兰",
    "BY": "白俄罗斯",
    "LT": "立陶宛",
    "PL": "波兰",
    "GR": "希腊",
    "IL": "以色列",
    "KW": "科威特",
    "AT": "奥地利",
    "US": "美国",
    "CA": "加拿大",
    "DE": "德国",
    "GB": "英国",
    "FR": "法国",
    "BR": "巴西",
    "IT": "意大利",
    "ES": "西班牙",
    "CL": "智利",
    "NO": "挪威",
    "SE": "瑞典",
    "IE": "爱尔兰",
    "PT": "葡萄牙",
    "FI": "芬兰",
    "DK": "丹麦",
    "CH": "瑞士",
    "AR": "阿根廷",
    "PE": "秘鲁",
    "MX": "墨西哥",
    "KZ": "哈萨克斯坦",
    "UZ": "乌兹别克斯坦",
    "AZ": "阿塞拜疆",
    "GE": "格鲁吉亚",
    "MD": "摩尔多瓦",
    "AM": "亚美尼亚",
    "MO": "中国澳门",
    "IN": "印度",
    "PK": "巴基斯坦",
    "NL": "荷兰",
    "RO": "罗马尼亚",
    "AU": "澳大利亚",
    "TR": "土耳其",
    "EC": "厄瓜多尔",
    "CO": "哥伦比亚",
    "ZA": "南非",
    "EG": "埃及",
    "NC": "全球",
  }
};

export default l10n;
